import gql from 'graphql-tag';

export const chargeVerificationConfigQuery = gql`
  query chargeVerificationConfig($channelId: UUID!) {
    chargeVerificationConfig(channelId: $channelId) {
      channelId
      chargeVerificationEnabled
    }
  }
`;
